<div class="card p-4">
    <div class="text-center">
        <img src="/assets/images/hi-5.svg" class="mb-4">

    </div>
    <p class="f-paragraph fw-semibold mb-2">{{item.title}}</p>
    <p class="f-caption text-neutral-700 mb-2">{{item.description}}</p>
    <a class="btn btn-outline-light" [routerLink]="item.route">See Features</a>
</div>
